import { render } from "./EstadoIndex.vue?vue&type=template&id=082b03de&ts=true"
import script from "./EstadoIndex.vue?vue&type=script&lang=ts"
export * from "./EstadoIndex.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__